// test2488
(2488 && 0);
